import React from "react";
import Chart from "react-apexcharts";
import global from "../../../common/utility/global";

export default function GraficoTotalVentasMensual(props) {
  var options = {
    series: props.series,
    chart: {
      type: "line",
      stacked: false,
      zoom: {
        enabled: false
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return global.decimalFormat(val.toFixed(2));
      },
    },
    stroke: {
      width: [1, 1, 4],
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            width: 500,
          }
        },
      }
    ],
    title: {
      text: "Cliente - Ranking Ventas Mensual (S/)",
      align: 'center',
      style: {
        fontSize: "18px",
        fontWeight: "bold",
        fontFamily: undefined,
        color: "#263238",
      },
    },
    xaxis: {
      categories: props.timeLine,
    },
    yaxis: [
      {
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: "#008FFB",
        },
        labels: {
          style: {
            colors: "#008FFB",
          },
          formatter: function (val) {
            return global.decimalFormat(val.toFixed(2));
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      {
        opposite: true,
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: "#00E396",
        },
        labels: {
          style: {
            colors: "#00E396",
          },
          formatter: function (val) {
            return global.decimalFormat(val.toFixed(2));
          },
        },
      },
      {
        opposite: true,
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: "#FEB019",
        },
        labels: {
          style: {
            colors: "#FEB019",
          },
          formatter: function (val) {
            return global.decimalFormat(val.toFixed(2));
          },
        },
      },
      {
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: "#ea4335",
        },
        labels: {
          style: {
            colors: "#ea4335",
          },
          formatter: function (val) {
            return global.decimalFormat(val.toFixed(2));
          },
        },
      },
    ],
    tooltip: {
      fixed: {
        enabled: true,
        position: "topLeft",
        offsetY: 30,
        offsetX: 60,
      },
    },
    legend: {
      horizontalAlign: "left",
      offsetX: 40,
    },
  };

  if (props.series.lenght > 0) {
    var chart = new Chart(document.querySelector("#chart"), options);
    chart.render();
  }

  return (
    <div id="chart">
      <Chart options={options} series={options.series} width="100%" height="500px" />
    </div>
  );
}
